export default __webpack_public_path__ + "static/poster-government-a6aeb108e11a7b094a0ef016f5769f6c.jpg";